import { ReactComponent as FacebookIcon } from "../../assets/images/svg/facebookIcon.svg";
import { ReactComponent as InstagramIcon } from "../../assets/images/svg/instagramIcon.svg";
import { ReactComponent as TwitterIcon } from "../../assets/images/svg/twitterIcon.svg";
import { ReactComponent as YelpIcon } from "../../assets/images/svg/yelpIcon.svg";
import FooterLogo from "../../assets/images/webp/overviewPage/footerLogo.webp";

import "./index.scss";

const Footer = () => {
  return (
    <div className="footer-container">
      <div className="footer">
        <div className="upper-footer">
          <div className="logo-white">
            <a href="#">
              <img className="logo-img" src={FooterLogo} alt="" />
            </a>
          </div>
          <div className="social-section">
            <div className="social-icons">
              <a className="social-icon" target="_blank" href="https://www.facebook.com/OmniActiveFitness">
                <FacebookIcon />
              </a>
              <a className="social-icon" target="_blank" href="https://www.instagram.com/omniactivefitness/">
                <InstagramIcon />
              </a>
              <a className="social-icon" target="_blank" href="https://twitter.com/Omni_Active">
                <TwitterIcon />
              </a>
              <a
                className="social-icon"
                target="_blank"
                href="https://www.yelp.com/biz/omni-active-fitness-cleveland-2"
              >
                <YelpIcon />
              </a>
            </div>
          </div>
          <div className="contact-section">
            <div className="contact-heading">Contact</div>
            <div className="contact-details">
              <div className="address">Cleveland, OH</div>
              <div className="number">(330) 888-8103</div>
              <div className="email-address">info@omniactive.com</div>
            </div>
          </div>
        </div>
        <div className="bottom-footer">© Copyright 2020 - | Omni-Active® Fitness | All rights reserved</div>
      </div>
    </div>
  );
};

export default Footer;
